import { useState } from 'react';
import styled from '@emotion/styled';
import Cookies from 'js-cookie';
import { Spacings, mediaQuery } from '@styles/index';
import getOfflineCentrePlans from '@cms/api';
import { getOfflineCentrePlansEndpoint } from '../apiHelper';
import StaticInfo from './StaticInfo';
import CitySection from './CitySection';
import PlanSelection from './PlanSelection';

const Wrapper = styled.div`
  display: flex;
  gap: ${Spacings.SPACING_14B};
  width: 1136px;
  margin: auto;
  margin-top: ${Spacings.SPACING_26B};
  ${mediaQuery.uptoTablet} {
    flex-direction: column-reverse;
    margin-top: ${Spacings.SPACING_18B};
    width: 100%;
    padding: ${Spacings.SPACING_4B};
  }
`;

const CitySelection = ({
  cmsData,
  cities,
  offlineCentrePlans,
  defaultCity
}) => {
  const accessToken = Cookies.get('accessToken');
  let currentCity = null;
  if (defaultCity) {
    currentCity = cities.find((city) => city.uid === defaultCity);
  }
  const [selectedCity, setSelectedCity] = useState(currentCity);
  const [offlinePlans, setOfflinePlans] = useState(offlineCentrePlans);

  const handleConfirmCity = async (city) => {
    if (!offlinePlans) {
      const offlineCentreData = await getOfflineCentrePlans(
        getOfflineCentrePlansEndpoint(city.uid),
        false,
        accessToken
      );
      setOfflinePlans(offlineCentreData);
    }
    setSelectedCity(city);
  };

  return (
    <Wrapper>
      <StaticInfo cmsData={cmsData} />
      {selectedCity && offlinePlans?.length ? (
        <PlanSelection
          selectedCity={selectedCity}
          offlineCentrePlans={offlinePlans}
        />
      ) : (
        <CitySection
          cities={cities}
          handleConfirmCity={handleConfirmCity}
          crmTrackingData={cmsData.crmTrackingData}
          defaultCity={selectedCity}
          otherCitiesList={cmsData.citiesList}
        />
      )}
    </Wrapper>
  );
};

export default CitySelection;
